
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2022/07/tribalism-news-july-2022",
      function () {
        return require("private-next-pages/blog-post/2022/07/tribalism-news-july-2022.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2022/07/tribalism-news-july-2022"])
      });
    }
  